import React, { useState, useRef, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import './Testimonials.css';
import axios from "axios";

const testimonials = [
    {
        title: "HIGHLY RECOMMENDED",
        description: "Promotors is the best place to go if you want high-quality work and a truly personalised experience. They are approachable and trustworthy.",
        name: "Aaron Almaraz",
        rating: 4,
    },
    {
        title: "GENUINE PRICES",
        description: "They charge a reasonable amount and offer great solutions to automotive issues. Thank you for your excellent work.",
        name: "Aaron Almaraz",
        rating: 5,
    },
    {
        title: "MUCH SATISFIED",
        description: "My car was not used for a long time. The AC of the car started blowing dust from its vents. I booked my service and they told me the air filter needed replacement.",
        name: "Aaron Almaraz",
        rating: 5,
    },
    {
        title: "GENUINE PRICES",
        description: "They charge a reasonable amount and offer great solutions to automotive issues. Thank you for your excellent work.",
        name: "Aaron Almaraz",
        rating: 5,
    },
    {
        title: "GENUINE PRICES",
        description: "They charge a reasonable amount and offer great solutions to automotive issues. Thank you for your excellent work.",
        name: "Aaron Almaraz",
        rating: 5,
    },
    // You can add more testimonials here
];

const TestimonialSlider = () => {
    const prevRef = useRef(null);
    const nextRef = useRef(null);
    const [reviewsData, setReviewsData] = useState([]);

    useEffect(() => {
        const fetchReviews = async () => {
            try {
                const response = await fetch("https://admin.ezerautomotive.co.nz/api/google-place-review/", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({ place_id: "ChIJL_F3dWcibW0RqLmRoKNIRIk" }),
                });

                const data = await response.json();
                setReviewsData(data.result);
            } catch (error) {
                console.error("Error fetching reviews:", error);
            }
        };

        fetchReviews();
    }, []);
    console.log(reviewsData, "review")
    return (
        <div className="testimonial-section">
            <div className="testimonial-header">
                <h2 className="testimonial-heading">RECENT REVIEW & RATING</h2>
                <div className="navigation-buttons">
                    <button ref={prevRef} className="nav-button">
                        <span>&lt;</span>
                    </button>
                    <button ref={nextRef} className="nav-button">
                        <span>&gt;</span>
                    </button>
                </div>
            </div>

            <Swiper
                modules={[Navigation]}
                spaceBetween={30}
                slidesPerView={3}
                loop={true}
                breakpoints={{
                    // when window width is >= 0px
                    0: {
                        slidesPerView: 1,
                    },
                    // when window width is >= 576px
                    576: {
                        slidesPerView: 2,
                    },
                    // when window width is >= 992px
                    992: {
                        slidesPerView: 3,
                    },
                    // when window width is >= 1200px
                    1200: {
                        slidesPerView: 3,
                    },
                }}
                navigation={{
                    prevEl: prevRef.current,
                    nextEl: nextRef.current,
                }}
                onBeforeInit={(swiper) => {
                    swiper.params.navigation.prevEl = prevRef.current;
                    swiper.params.navigation.nextEl = nextRef.current;
                }}
                className="testimonial-swiper"
            >
                {reviewsData?.reviews
                    ?.filter(item => item.rating >= 4)
                    .map((item, index) => (
                        <SwiperSlide key={index}>
                            <div className="testimonial-card">
                                <div className="testimonial-title">
                                    {/* <span className="quote-icon">❝</span> {item.title} */}
                                </div>
                                <p className="testimonial-description" style={{ textAlign: 'justify' }}>
                                    {item.text}
                                </p>
                                <hr className="divider" />
                                <div className="testimonial-footer">
                                    <div className="testimonial-name">{item.author_name}</div>
                                    <div className="testimonial-stars">
                                        {Array.from({ length: item.rating }).map((_, i) => (
                                            <span key={i}>⭐</span>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </SwiperSlide>
                    ))}

            </Swiper>
        </div>
    );
};

export default TestimonialSlider;
